<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :default-tenant-language="defaultTenantLanguage"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/CreditNoteTypes/Form'

export default {
    name: 'CreditNoteTypeCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.credit-note-types.store'))
        }
    }
}
</script>
